
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import Popup from '@/components/popup/popup.vue'
import BytedIconAiming from '@byte-design/vue-icons/icons/Aiming'
import { AllObjectiveList, getAdditionalObjectiveList, openedObjectives } from '@/const/fastCreation'
import * as tool from '@/utils/tool'
import { CampaignObjectiveValue } from '@/const/state/campaign'

const MORE_OBJECTIVES_FLAG = 'show_more_objectives'

@Component({
  components: {
    Popup,
    BytedIconAiming
  }
})
export default class ForwardPC extends Vue {
  @Getter('account/engagementEnabled') engagementEnabled: boolean
  @Getter('account/hasAd') hasAd: boolean
  @Getter('account/adverId') aadvid: string

  ObjectiveList = AllObjectiveList
  show = false
  checked = []
  submitedFlag = false // 是否已提交过

  @Watch('show', { immediate: true })
  handleShow(val: boolean) {
    if (!val) {
      return
    }
    this.$nextTick(() => {
      this.$refs.topc.scrollTo({ top: 0 })
    })
  }

  get btnText(): string {
    if (this.submited) {
      return this.$t('fastcreation_moreobj_access')
    }
    return this.$t('fastcreation_moreobj_submit')
  }

  /** 之前用户提交过more objectives */
  get submited(): boolean {
    return this.submitedFlag || (localStorage.getItem(MORE_OBJECTIVES_FLAG) ?? '') === `${this.aadvid}`
  }

  get disabled(): boolean {
    return !this.submited && !this.checked.length
  }

  created() {
    const openedObjList = openedObjectives.slice()
    if (this.engagementEnabled) {
      openedObjList.push(CampaignObjectiveValue.CommunityInteraction)
    }
    const temp = getAdditionalObjectiveList(openedObjList)
    this.ObjectiveList = temp
  }

  async reportObjective() {
    try {
      if (!this.submited && this.checked.length) {
        this.checked.forEach(check => {
          this.$trackEvent('adp_waplite_click', {
            fastcr_objective: check
          })
        })
        localStorage.setItem(MORE_OBJECTIVES_FLAG, this.aadvid)
        this.submitedFlag = true
      }

      this.show = false

      tool.accessPC()

    } catch (e) {
      this.$toast({
        type: 'error',
        message: this.$t('common_retry')
      })
    }
  }
}
